// @flow
import styled from 'styled-components'
import { Layout, Card } from 'antd'
const { Content } = Layout

export const StyledDetailsCard = styled(Card)`
    margin-bottom: 50px !important;
    
    .ant-card-head {
      background: #eee;
    }
`


// WEBPACK FOOTER //
// ./src/components/setup-and-settings/style.js